import React from 'react';
import SVGIcon from '@atlaskit/icon/svg';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { B400, N10, N100, N40 } from '@atlaskit/theme/colors';
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */
const CheckboxIcon = ({
  checked
}) => {
  return /*#__PURE__*/React.createElement(SVGIcon, {
    label: "",
    size: "medium",
    primaryColor: checked ? `var(--ds-background-selected-bold, ${B400})` : `var(--ds-background-input, ${N10})`,
    secondaryColor: checked ? `var(--ds-icon-inverse, ${N10})` : 'transparent'
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: "6",
    y: "6",
    width: "12",
    height: "12",
    rx: "2",
    stroke: checked ? `var(--ds-border-selected, ${B400})` : `var(--ds-border-input, ${getBooleanFF('platform.design-system-team.border-checkbox_nyoiu') ? N100 : N40})`,
    strokeWidth: getBooleanFF('platform.design-system-team.border-checkbox_nyoiu') ? 1 : 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
    fill: "inherit"
  })));
};
export default CheckboxIcon;